<button class="call-btn" (click)="onClick()">
	Llamar<img src="./assets/images/phone-telephone.png" alt="Telefono logo" />
</button>
